export type {
  CardHeaderSlots,
  CardHeaderBaseProps as CardHeaderProps,
  CardHeaderBaseState as CardHeaderState,
} from '@fluentui/react-card';
